export default __webpack_public_path__ + "static/media/icon_search_filled.b23f3b03.svg";